import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchRecentConfidenceScores = async (testStepId) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getRecentConfidenceScores&companyid=${user.companyid}&testStepId=${testStepId}`,
  );

  return response.data;
};

const useGetRecentConfidenceScoresQuery = (testStepId, options = {}) => {
  return useQuery({
    queryKey: ["recentConfidenceScores", testStepId],
    queryFn: () => fetchRecentConfidenceScores(testStepId),
    enabled: options.enabled,
  });
};

export default useGetRecentConfidenceScoresQuery;